import { createApp, h } from 'vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import PromptDialog from '@/components/PromptDialog.vue'
import Toast from '@/components/Toast.vue'

let confirmVm: any = null
let promptVm: any = null
let toastVm: any = null

function ensureConfirm() {
  if (confirmVm) return confirmVm
  const el = document.createElement('div')
  document.body.appendChild(el)
  const app = createApp(ConfirmDialog)
  const instance = app.mount(el)
  confirmVm = instance
  return confirmVm
}

function ensurePrompt() {
  if (promptVm) return promptVm
  const el = document.createElement('div')
  document.body.appendChild(el)
  const app = createApp(PromptDialog)
  promptVm = app.mount(el)
  return promptVm
}

function ensureToast() {
  if (toastVm) return toastVm
  const el = document.createElement('div')
  document.body.appendChild(el)
  const app = createApp(Toast)
  const instance = app.mount(el)
  toastVm = instance
  return toastVm
}

export interface ConfirmOptions {
  title: string
  message: string
  confirmText?: string
  cancelText?: string
  variant?: 'danger' | 'info'
}

export const showConfirm = (options: ConfirmOptions): Promise<boolean> => {
  const vm = ensureConfirm()
  return vm.show(options)
}

export interface PromptOptions {
  title: string
  message?: string
  label?: string
  placeholder?: string
  defaultValue?: string
  inputType?: 'text' | 'password'
  confirmText?: string
  cancelText?: string
}

export const showPrompt = (options: PromptOptions): Promise<string | null> => ensurePrompt().show(options)

export const showToast = (type: 'success' | 'error' | 'warning' | 'info', message: string, title?: string, duration?: number) => {
  const vm = ensureToast()
  vm.addToast(type, message, title, duration)
}

export default {
  showConfirm,
  showPrompt,
  showToast
}
